import { Vue } from 'vue-property-decorator';

import { JsonSchemaType } from '@evidentid/json-schema/interfaces/JsonSchema';

export const EID_JSON_SCHEMA_COMPONENTS: Partial<Record<JsonSchemaType, Vue.Component | Vue.AsyncComponent>> = {};
